import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as ArticleActions from './article.action';
import { ArticleService } from './article.service';
import { BannerService } from '../../shared/services/banner.service';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { empty } from 'rxjs';
import * as ArticleModels from '../../models/articles/articles';


export interface ArticleStateModel {
  ArticleDictionary: ArticleModels.ArticlesDictionaryListModel;
  }

@State<ArticleStateModel>({
    name: 'articleState',
    defaults: {
      ArticleDictionary: null,
    }
  })

  @Injectable()

  export class ArticleState {

    constructor(
      private helperService: HelperService,
      private articleService: ArticleService,
      private bannerService: BannerService
    ) { }

  @Selector()
  static ArticleDictionary(state: ArticleStateModel) {
    return state.ArticleDictionary;
  }



  @Action(ArticleActions.GetArticleDictionary)
  getArticleDictionary(
    context: StateContext<ArticleStateModel>,
  ) {

    const errorMessage = 'Błąd pobierania słownika artykułów.';

    context.setState(
      patch({
        ArticleDictionary: null
      })
    );

    this.articleService.getDictionary().subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            ArticleDictionary: ret
          })
        );
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {

        this.helperService.SaveException('ArticleActions.GetArticleDictionary', error);

        this.bannerService.error(errorMessage);
      });
  }

  }

